// Persistence for the feedback popup state.
// - SUBMITTED_KEY lives in localStorage: permanent and shared across every tab of the
//   site, so answering once (in the popup or on /feedbacks) silences it for good.
// - DISMISSED_KEY lives in sessionStorage: closing the popup only snoozes the
//   auto-open for the current tab/session.
export const SUBMITTED_KEY = 'FEEDBACK_SUBMITTED'
export const DISMISSED_KEY = 'feedbackDismissed'

// Storage access throws in Safari private mode / when cookies are blocked, and this
// runs inside the app shell on every page, so every access is guarded.
function readFlag(storage, key) {
  try {
    return storage.getItem(key) === 'true'
  } catch {
    return false
  }
}

function writeFlag(storage, key) {
  try {
    storage.setItem(key, 'true')
  } catch {
    // ignore: the popup just re-appears on the next visit
  }
}

export function isFeedbackSubmitted() {
  return readFlag(window.localStorage, SUBMITTED_KEY)
}

export function markFeedbackSubmitted() {
  writeFlag(window.localStorage, SUBMITTED_KEY)
}

export function isFeedbackDismissed() {
  return readFlag(window.sessionStorage, DISMISSED_KEY)
}

export function markFeedbackDismissed() {
  writeFlag(window.sessionStorage, DISMISSED_KEY)
}
